import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Breadcrumbs, Link, Container } from '@mui/material';
import { UserButton, OrganizationSwitcher } from '@clerk/clerk-react';
import Navigation from './Navigation';
import GlobalAIAssistant from './GlobalAIAssistant';
import { Outlet, Link as RouterLink, useLocation } from 'react-router-dom';
import { NavigateNext } from '@mui/icons-material';

const MainLayout: React.FC = () => {
  const [navigationOpen, setNavigationOpen] = useState(true);
  const location = useLocation();

  const handleNavigationToggle = () => {
    setNavigationOpen(!navigationOpen);
  };

  const pathSegments = location.pathname.split('/').filter(segment => segment);
  const breadcrumbs = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');
    const label = segment.charAt(0).toUpperCase() + segment.slice(1).replace('-', ' ');
    
    return {
      label,
      path,
      isLast: index === pathSegments.length - 1
    };
  });

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Navigation open={navigationOpen} onToggle={handleNavigationToggle} />
      
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <AppBar 
          position="static" 
          sx={{ 
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'background.paper',
            color: 'text.primary',
            boxShadow: 1
          }}
        >
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              {breadcrumbs.length > 0 && (
                <Breadcrumbs 
                  separator={<NavigateNext fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Link
                    component={RouterLink}
                    to="/dashboard"
                    underline="hover"
                    color="inherit"
                  >
                    Home
                  </Link>
                  {breadcrumbs.map((crumb, index) => (
                    crumb.isLast ? (
                      <Typography key={index} color="text.primary">
                        {crumb.label}
                      </Typography>
                    ) : (
                      <Link
                        key={index}
                        component={RouterLink}
                        to={crumb.path}
                        underline="hover"
                        color="inherit"
                      >
                        {crumb.label}
                      </Link>
                    )
                  ))}
                </Breadcrumbs>
              )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <OrganizationSwitcher hidePersonal />
              <UserButton afterSignOutUrl="/" />
            </Box>
          </Toolbar>
        </AppBar>
        
        <Box sx={{ flexGrow: 1, overflow: 'auto', backgroundColor: '#f5f5f5' }}>
          <Container maxWidth={false} sx={{ py: 3, height: '100%' }}>
            <Outlet />
          </Container>
        </Box>
      </Box>
      
      {/* Global AI Assistant - Available on all pages */}
      <GlobalAIAssistant />
    </Box>
  );
};

export default MainLayout;